<app-navbar></app-navbar>

<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="premium-page-header mb-5 text-center">
                    <h1 class="ultimate-3d-title">Video Gallery</h1>
                    <div class="premium-header-divider mx-auto mt-3"></div>
                </div>

                <ng-container *ngIf="VideoAlbums == null" class="spinner-overlay">
                    <div class="text-center py-5">
                        <div class="ultimate-3d-card p-5 mx-auto" style="max-width: 400px;">
                            <i class="fa-solid fa-video" style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                            <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Albums Found</h3>
                        </div>
                    </div>
                </ng-container>

                <div class="row g-4 justify-content-center" *ngIf="VideoAlbums != null">
                    <ng-container *ngFor="let album of VideoAlbums">
                        <div class="col-lg-4 col-md-6">
                            <a [routerLink]="['/videoFolder', album.Id]" class="text-decoration-none">
                                <div class="ultimate-3d-card gallery-3d-card h-100 d-flex flex-column">
                                    <div class="gallery-image-wrapper youtube-wrapper d-flex align-items-center justify-content-center" style="background: rgba(13, 139, 84, 0.1);">
                                        <img [src]="'/assets/img/youtube.png'" class="img-fluid" style="width: 80px; height: 80px; object-fit: contain;" alt="Video Album" (load)="onImageLoad()" />
                                    </div>
                                    <div class="gallery-content p-4 text-center flex-grow-1 d-flex align-items-center justify-content-center">
                                        <h3 class="gallery-title m-0">{{ album.Name }}</h3>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </ng-container>
                </div>

            </div>
        </div>
    </div>
</section>
